import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {PdfPreviewModalComponent} from './pdf-preview-modal.component';
import {PdfPreviewModule} from '../pdf-preview/pdf-preview.module';
import {ModalModule} from '../../../../components/common/modal/modal.module';
import {ButtonModule} from '../button/button.module';
import {DialogModule} from '../../../common/dialog/dialog.module';
import {TablerIconsProvider} from "angular-tabler-icons";
import {IconDownload, IconPrinter} from "angular-tabler-icons/icons";
@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        PdfPreviewModule,
        ModalModule,
        ButtonModule,
        DialogModule,
    ],
    exports: [
        PdfPreviewModalComponent,
    ],
    providers: [
        TablerIconsProvider.pick({IconDownload, IconPrinter})
    ],
    declarations: [
        PdfPreviewModalComponent
    ]
})
export class PdfPreviewModalModule {
}
